import { FunctionComponent } from 'react';

import { GameRoot, L12nText } from '@pp/core';

import { BetLimitsConnected } from './components/betLimits/BetLimitsConnected';
import { GameBackgroundConnected } from './components/gameBackground/GameBackgroundConnected';
import { GameGridConnected } from './components/gameGrid';
import { helpConfig } from './components/help';
import { NavControlsConnected } from './components/navControls';
import { MWGameCommunicationControllerConfig } from './controllers/gameCommunication/config';
import { GameStore } from './store/GameStore';
import {
  BetIds,
  Resources,
  MWCoreTimings,
  tableConfigOptions,
  GameVolumeChannels,
  soundResources,
  MegaWheelTrafficLightConfig,
  languages,
} from './config';

const config = {
  betConfig: BetIds,
  helpConfig: helpConfig,
  playAreaSize: 0,
  soundResources,
  resources: Resources,
  tableConfigOptions,
  uiVolumeChannel: GameVolumeChannels.Game,
  volumeChannels: GameVolumeChannels,
  gameStore: GameStore,
  gameCommunicationConfig: MWGameCommunicationControllerConfig,
  defaultTimings: MWCoreTimings,
  trafficLightConfig: MegaWheelTrafficLightConfig,
  languages,
};

const soundControls = [
  {
    channel: GameVolumeChannels.Studio,
    label: <L12nText tk="STUDIO_SOUNDS_SETTINGS" />,
    description: <L12nText tk="ADJUST_STUDIO_EFFECTS" />,
    disabledWithStream: true,
  },
  {
    channel: GameVolumeChannels.Game,
    label: <L12nText tk="GAMEEFFECTS" />,
    description: <L12nText tk="ADJUST_SOUND_EFFECTS" />,
  },
];

export const Game: FunctionComponent = () => {
  return (
    <GameRoot
      config={config}
      background={<GameBackgroundConnected />}
      navControls={<NavControlsConnected />}
      betLimitContent={<BetLimitsConnected />}
      soundControls={soundControls}
    >
      <GameGridConnected />
    </GameRoot>
  );
};
